'use client';

import * as ToggleGroup from "@radix-ui/react-toggle-group";
import { Item } from "../course-page/filters";

export const ChooseHoles = ({
    holes,
    setHoles,
    isDisabled,
    availableHoles,
    className,
    id,
}: {
    holes: 9 | 18;
    setHoles: (v: 9 | 18) => void;
    isDisabled?: boolean;
    availableHoles?: (9 | 18)[];
    className?: string;
    id?: string;
}) => {
    const holesOptions: { value: 18 | 9; label: string }[] = [
        { value: 18, label: "18" },
        { value: 9, label: "9" },
    ];

    const handleHolesChange = (value: string) => {
        if (!value) return;
        const numericValue = Number(value) as 9 | 18;
        if (
            isDisabled ||
            (availableHoles && !availableHoles.includes(numericValue))
        ) {
            return;
        }
        setHoles(numericValue);
    };

    return (
        <ToggleGroup.Root
            type="single"
            value={String(holes)}
            onValueChange={handleHolesChange}
            orientation="horizontal"
            className={`flex ${className}`}
            data-testid="holes-button-id"
            id={id}
        >
            {holesOptions.map((option, index) => {
                const isUnavailable =
                    availableHoles && !availableHoles.includes(option.value);
                return (
                    <Item
                        key={option.value}
                        value={String(option.value)}
                        label={`${option.label} holes`}
                        dataTestId="tee-time-holes-id"
                        dataQa={String(option.value)}
                        className={`${index === 0 ? "rounded-l-full" : "rounded-r-full"}
                            border py-1 z-[1] border-gray-300 text-sm font-medium
                            data-[state=on]:bg-primary data-[state=on]:text-white
                            data-[state=off]:text-gray-700 whitespace-nowrap h-[33px]
                            ${isUnavailable || isDisabled
                                ? "opacity-50 cursor-not-allowed"
                                : "cursor-pointer"
                            }`}
                    />
                );
            })}
        </ToggleGroup.Root>
    );
};